<template>
  <div class="p-edu">
    <div class="p-block">
      <div class="p-block-title">
        <p class="main">{{ baseData.title }}</p>
        <p class="sub">{{ baseData.subtitle }}</p>
      </div>
    </div>
    <KdTab :navigationTab="tabList" @selected="selectedFn"></KdTab>
    <SlickCarousel
      v-for="(item, index) in baseData.tabs" :index="index" :key="index"
      className="edu"
      :baseData="item.obj"
      :textLeft="true"
      :class="{ hide: index !== tabIndex }"
    />
    <div class="p-block-more">
      <kd-link
        type="primary"
        @click="
          $emit('homeCallback', {
            dwClickName: 'Schedule',
          })
        "
      >
        <KdIcon
          icon="Vcr"
          :size="24"
          fill="currentColor"
          margin="0 6px 0 0"
          rightText="预约演示"
          textSize="18"
        ></KdIcon>
      </kd-link>
    </div>
  </div>
</template>

<script>
import { eduData } from '@/views/homeV2/config.js';
import KdTab from '@/components/KdTab/index.vue';
import KdIcon from '@/components/KdIcon/index.vue';
import SlickCarousel from '@/components/SlickCarousel/index.vue';

export default {
  name: 'edu-component',
  components: { KdTab, SlickCarousel, KdIcon },
  data() {
    return {
      tabList: ['AI校企版', 'AI提效助手'],
      tabIndex: 0,
      baseData: eduData,
    };
  },
  methods: {
    selectedFn(index) {
      this.tabIndex = Number(index);
    },
  },
};
</script>